module.exports = __webpack_public_path__ + "static/media/how_to_reg_selected.b0051448.svg";